export const WELCOME_ICON = require("./assets/clear_intro_icon.png");
export const LOGIN_SCREEN_ICON = require("./assets/LoginScreen.png");